import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Statistic } from "semantic-ui-react";
import { observer } from "mobx-react";
import TourStatistic from "~/models/TourStatistic";

const TourStats = props => {
  const { tourStatistic, t } = props;
  return (
    <>
      <Statistic.Group>
        <Statistic>
          <Statistic.Value>{tourStatistic.totalLifetimeImageViews}</Statistic.Value>
          <Statistic.Label>{t("clientPanelStats:totalPhotosViewed")}</Statistic.Label>
        </Statistic>
        <Statistic>
          <Statistic.Value>{tourStatistic.totalLifetimeTourViews}</Statistic.Value>
          <Statistic.Label>{t("clientPanelStats:totalTourViews")}</Statistic.Label>
        </Statistic>
        <Statistic>
          <Statistic.Value>{tourStatistic.totalLifetimeVisitors}</Statistic.Value>
          <Statistic.Label>{t("clientPanelStats:totalVisitors")}</Statistic.Label>
        </Statistic>
        <Statistic>
          <Statistic.Value>{tourStatistic.totalImagesViewedPerVisitor}</Statistic.Value>
          <Statistic.Label>{t("clientPanelStats:imagesViewedPerVisitor")}</Statistic.Label>
        </Statistic>
      </Statistic.Group>
    </>
  );
};
TourStats.propTypes = {
  tourStatistic: PropTypes.instanceOf(TourStatistic),
  t: PropTypes.func.isRequired,
};

export default withTranslation()(observer(TourStats));
